import { ExternalLink } from "lucide-react";
import Reveal from "@/components/escape21/Reveal";

const CAROUSELS = [
  {
    title: "é só 1% por dia… mas muda tudo",
    stats: [
      ["42k", "alcance"],
      ["2,5k", "curtidas"],
      ["560", "salvamentos"],
      ["340", "shares"],
    ],
    thumbnail: "/lovable-uploads/4c9eb56c-1640-4752-b265-1a3267b83543.png",
    link: "https://www.instagram.com/p/DJaQfI3y-L6/?img_index=1",
  },
  {
    title: "ou tu muda o ambiente… ou ele muda quem tu é",
    stats: [
      ["2.026", "curtidas"],
      ["434", "shares"],
      ["373", "salvamentos"],
    ],
    thumbnail: "/lovable-uploads/710219d6-587a-4680-8310-b6e7abc275ca.png",
    link: "https://www.instagram.com/p/DNCAbEHMiV8/?img_index=1",
  },
];

const Carousels = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          carrosséis
        </span>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          conteúdo que a galera <span className="e21-serif text-green-400">salva</span> pra rever.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
        {CAROUSELS.map((c, i) => (
          <Reveal
            key={c.link}
            delay={i * 100}
            className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 transition-colors hover:bg-white/[0.08]"
          >
            <a href={c.link} target="_blank" rel="noopener noreferrer" className="block">
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={c.thumbnail}
                  alt={c.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <ExternalLink
                  size={18}
                  className="absolute right-4 top-4 text-white/70 transition-colors group-hover:text-white"
                />
              </div>
              <div className="p-6">
                <h3 className="text-base font-bold tracking-[-0.02em] text-white">"{c.title}"</h3>
                <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm">
                  {c.stats.map(([value, label]) => (
                    <span key={label}>
                      <span className="font-bold text-white">{value}</span>
                      <span className="text-white/50"> {label}</span>
                    </span>
                  ))}
                </div>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Carousels;
